export default "__VITE_ASSET__54e4e58f__"